import React, { useState, useEffect } from 'react';
import { SubTabs } from 'shared/components';
import { HaierCostingStatus } from 'views/Costing/common/model/haierCostingStatus.model';
import { axiosErp } from 'shared/config/axios';
import { getStoredAuthToken } from 'shared/utils/authToken';

interface HaierCostingTabsProps {
  name: string;
  tab: HaierCostingStatus;
  onChange: (tab: HaierCostingStatus) => void;
}

type CostingStatusProps = {
  waiting: number;
  verify: number;
  approve: number;
  reject: number;
  edit: number;
};

const HaierCostingTabs: React.FC<HaierCostingTabsProps> = (props) => {
  const token = getStoredAuthToken();
  const { tab, onChange, name } = props;

  const [data, setData] = useState<CostingStatusProps>({
    waiting: 0,
    verify: 0,
    approve: 0,
    reject: 0,
    edit: 0,
  });

  const functionGetData = async () => {
    try {
      const costingData = await axiosErp(token).get(`/costing-job-table-count`);
      setData(costingData.data);
    } catch (error) {
      console.error('ERROR TO LOAD COSTING STATUS: ', error);
    }
  };

  const checkSelectTab = (id: HaierCostingStatus) => {
    return id === tab && name === 'costing';
  };

  const selectTab = (index: HaierCostingStatus) => {
    functionGetData();
    onChange(index);
  };

  useEffect(() => {
    functionGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabs = [
    {
      id: HaierCostingStatus.WAITING_CONFIRM,
      name: 'รอยืนยัน',
      color: 'badge-grey',
      count: data?.waiting || 0,
      divider: false,
    },
    {
      id: HaierCostingStatus.TO_VERIFY,
      name: 'รอตรวจสอบ',
      color: 'badge-grey',
      count: data?.verify || 0,
      divider: false,
    },
    {
      id: HaierCostingStatus.APPROVED,
      name: 'ตรวจสอบแล้ว',
      color: 'badge-grey',
      count: data?.approve || 0,
      divider: true,
    },
    {
      id: HaierCostingStatus.REJECT,
      name: 'ปฎิเสธ',
      color: 'badge-grey',
      count: data?.reject || 0,
      divider: false,
    },
    {
      id: HaierCostingStatus.EDIT,
      name: 'แก้ไข',
      color: 'badge-grey',
      count: data?.edit || 0,
      divider: false,
    },
  ].map((item) => ({
    id: item.id,
    name: item.name,
    count: item.count,
    active: checkSelectTab(item.id),
    clicked: () => selectTab(item.id),
    badgeClassName: checkSelectTab(item.id) ? item.color : null,
    divider: item.divider,
  }));

  return <SubTabs tabs={tabs} />;
};

export default HaierCostingTabs;
